import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Col } from './Col';
import { Grid } from './Grid';
import { Button } from './Button';

const StyledForm = styled.form`
  background: ${(props) =>
    props.$isGradient
      ? `linear-gradient(90deg, ${props.$bgColorStart}, ${props.$bgColorMid}, ${props.$bgColorEnd})`
      : props.$bgColor};
`;

const StyledHeadline = styled.p`
  color: ${(props) => props.$color} !important;
`;

const Form = ({ formName, sanity }) => {
  const { colors, form } = sanity;

  const [contact, setContact] = useState({});

  const handleChange = (e) =>
    setContact({ ...contact, [e.target.name]: e.target.value });

  const renderFormFields = () => {
    return form?.formFields?.map((formField, index) => {
      if (formField?.type === 'textarea') {
        return (
          <Col key={index} classes="lg:col-span-2">
            <textarea
              name={formField?.label}
              rows="3"
              value={contact[formField?.label] || ''}
              onChange={handleChange}
              placeholder={formField?.placeholder}
              required={formField?.required === true}
              className="block w-full rounded-md border-zinc-300 shadow-sm focus:border-zinc-500 focus:ring-zinc-500 sm:text-sm"
            />
          </Col>
        );
      } else if (formField?.type === 'select') {
        const options = formField?.options || [];
        return (
          <Col key={index}>
            <select
              name={formField?.label}
              value={contact[formField?.label] || ''}
              onChange={handleChange}
              required={formField?.required === true}
              className="block w-full rounded-md border-zinc-300 py-2 pl-3 shadow-sm focus:border-zinc-500 focus:ring-zinc-500 sm:text-sm"
            >
              <option value="" disabled hidden>
                {formField?.placeholder}
              </option>
              {options.map((option, i) => (
                <option key={i} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </Col>
        );
      } else {
        return (
          <Col key={index}>
            <input
              name={formField?.label}
              type={formField?.type}
              value={contact[formField?.label] || ''}
              onChange={handleChange}
              placeholder={formField?.placeholder}
              required={formField?.required === true}
              className="block w-full rounded-md border-zinc-300 py-2 pl-3 shadow-sm focus:border-zinc-500 focus:ring-zinc-500 sm:text-sm"
            />
          </Col>
        );
      }
    });
  };

  return (
    <StyledForm
      name={formName}
      method="POST"
      action="/thank-you/"
      data-netlify="true"
      data-netlify-honeypot="bot-field"
      className="relative max-w-4xl rounded-xl border-2 px-4 pb-8 pt-6 shadow-xl lg:mx-auto lg:px-6 lg:py-8"
      id={formName}
      $isGradient={form?.isGradient}
      $bgColor={colors?.primary?.default}
      $bgColorStart={colors?.primary?.darker}
      $bgColorMid={colors?.primary?.default}
      $bgColorEnd={colors?.primary?.darker}
    >
      <div className="space-y-8">
        <div className="">
          <StyledHeadline
            className="text-center text-4xl font-bold"
            $color={
              form?.headlineColor?.color
                ? form?.headlineColor?.color
                : colors?.accent?.default
            }
          >
            {form?.headline}
          </StyledHeadline>
        </div>
        <input type="hidden" name="form-name" value={formName} />

        <Grid classes="gap-x-4 gap-y-4 lg:grid-cols-2">
          {renderFormFields()}
        </Grid>

        <div className="text-center">
          <Button
            linkType="form"
            label={form?.ctaButtonLabel}
            sanity={sanity}
          />
        </div>
      </div>
    </StyledForm>
  );
};

Form.defaultProps = {
  formName: '',
  colors: {},
  form: {},
};

// ADDED: propTypes
Form.propTypes = {
  formName: PropTypes.string,
  colors: PropTypes.object,
  form: PropTypes.object,
};

export { Form };
